import React, { useEffect, useState } from 'react';
import moment from 'moment';
import helper from 'services/helper';
const  { numberWithZero } = helper.FN

function CountdownTimer({ expireDateTime = null, onExpire = null  }) {
  const targetDate = expireDateTime ? moment(expireDateTime) : moment(); // Replace with your target date and time
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());

  function calculateTimeRemaining(countLoop = 0) {
    const now = moment(); // สร้างเวลาปัจจุบันใน UTC+0
    const nowMinus7Hours = now.subtract(7, 'hours');
    const timeDifference = moment.duration(targetDate.diff(nowMinus7Hours));
    console.log(timeDifference)
    if (timeDifference.asMilliseconds() <= 0) {
      // Countdown has ended

      if( expireDateTime != null && onExpire) {
        console.log('AA onExpire', expireDateTime, countLoop)
        onExpire()
      }

      return { days: 0, hours: 0, minutes: 0, seconds: 0, };
    }

    const days = timeDifference.asDays();
    const hours = timeDifference.hours();
    const minutes = timeDifference.minutes();
    const seconds = timeDifference.seconds();

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
  let countLoop = 0
    const interval = setInterval(() => {
      const remaining = calculateTimeRemaining(countLoop);
      if (remaining.days === 0 && remaining.hours === 0 && remaining.minutes === 0 && remaining.seconds === 0) {
        clearInterval(interval); // Stop the interval if the countdown has expired
      } else {
        setTimeRemaining(remaining);
      }
      countLoop++
    }, 1000);

    return () => clearInterval(interval);
  }, [onExpire]);

  return `${numberWithZero(timeRemaining.hours,2)}:${numberWithZero(timeRemaining.minutes,2)}:${numberWithZero(timeRemaining.seconds,2)}`
}

export default CountdownTimer
